import { twMerge } from '@/utils/index';
import { type ClassValue, clsx } from 'clsx';

const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export default cn;
